import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getHome, { HomeSectionData, HomeSectionType } from "../getHome";

const sections: HomeSectionData[] = [
  {
    type: HomeSectionType.Cigs,
  },
  {
    type: HomeSectionType.UpcomingEvents,
  },
  {
    type: HomeSectionType.Games,
  },
];

const useGetHome = (userID?: string, autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } =
    useRequestState<HomeSectionData[]>(sections);

  const send = useCallback(async () => {
    setLoading();
    try {
      const listings = await getHome(userID);
      setSuccess(listings);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [userID, setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [userID, autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetHome;
